import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-white border-t border-gray-100" data-id="element-32">
      <div className="max-w-3xl mx-auto text-center" data-id="element-33">
        <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-8 leading-tight" data-id="element-34">
          ❤️ La infancia de tus hijos no se pausa
        </h2>

        <div className="space-y-6 text-xl text-gray-700 font-medium mb-12" data-id="element-35">
          <p data-id="element-36">No necesitás más paciencia. Necesitás mejores herramientas.</p>
          <p data-id="element-37">Y hoy podés empezar a usarlas.</p>
          <p className="text-2xl font-bold text-gray-900 mt-8" data-id="element-38">
            Dentro de unos años, tus hijos no van a recordar los gritos. Van a
            recordar el día en que todo cambió.
          </p>
        </div>

        <CTAButton text="👉 QUIERO EL MÉTODO CALMA® AHORA" onClick={scrollToPricing} data-id="element-39" />
      </div>
    </section>;
}